var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    display: "none"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M43.498,27.833H11.502V8.851h31.996V27.833z M13.002,26.333h28.996V10.351H13.002V26.333z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "30.729,21.812 24.272,21.812 12.591,10.131 13.651,9.07 24.894,20.312 30.105,20.312 41.35,9.07  42.409,10.131  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.318,
    y: 21.968,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 47.9358 65.2917)",
    fill: "#00A79D",
    width: 12.344,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.76,
    y: 16.547,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 13.8263 51.165)",
    fill: "#00A79D",
    width: 1.5,
    height: 12.344
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.54b83c21d31d03819d490fbb8bf1f901.svg";
export { ForwardRef as ReactComponent };